import { render, staticRenderFns } from "./VFlaggingForm.vue?vue&type=template&id=6baa981d&"
import script from "./VFlaggingForm.vue?vue&type=script&lang=js&"
export * from "./VFlaggingForm.vue?vue&type=script&lang=js&"
import style0 from "./VFlaggingForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports